import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Result, Space, Spin } from "antd";
import { useRequest } from "ahooks";
import { useState } from "react";
import { PageContainer } from "@/components/PageContainer";
import { CommonComponent } from "@/components/Show";
import { TraceAuditStatusEnum } from "@/enums";
import apis from "@/services";
import { AuditPass, RejectReasonView, TraceDetail } from "./-traceAudit";

export const Route = createFileRoute("/_layout/opr/traceAuditDetail")({
  validateSearch: (search: Record<string, unknown>) => ({
    traceId: String(search.traceId ?? ""),
  }),
  staticData: {
    menuLabel: "溯源详情",
    menuHighlightPath: "/opr/traceAudit",
  },
  component: TraceAuditDetail,
});

function TraceAuditDetail() {
  const { traceId } = Route.useSearch();
  const navigate = useNavigate();
  const [detailVersion, setDetailVersion] = useState(0);

  const tag = useRequest(() =>
    apis.source
      .getTraceTagList({
        page: 1,
        size: 10000,
      })
      .then((res) =>
        res?.data?.list?.map((tag) => ({ label: tag.name ?? "", value: tag.id ?? "" }))
      )
  );

  const detail = useRequest(() =>
    apis.source.getTraceActivityDetail({ traceId }).then((res) => res.data)
  );

  const refreshDetail = () => {
    detail.run();
    setDetailVersion((version) => version + 1);
  };

  return (
    <PageContainer
      className="trace-audit-detail-page"
      showBack
      onBack={() => navigate({ to: "/opr/traceAudit" })}
      breadcrumbItems={[
        { title: <span className="dakeadmin-page-container-crumb-root">运营管理</span> },
        {
          title: (
            <a
              className="dakeadmin-page-container-crumb-link"
              href="/opr/traceAudit"
              onClick={(e) => {
                e.preventDefault();
                navigate({ to: "/opr/traceAudit" });
              }}
            >
              溯源审核
            </a>
          ),
        },
        { title: <span className="dakeadmin-page-container-crumb-current">溯源详情</span> },
      ]}
      extra={
        <CommonComponent.Show when={detail.data?.auditStatus === TraceAuditStatusEnum.PENDING}>
          <Space>
            <AuditPass
              list={tag.data}
              btnType="primary"
              traceId={traceId}
              callback={refreshDetail}
            />
            <RejectReasonView
              btnType="primary"
              traceId={traceId}
              callback={refreshDetail}
            />
          </Space>
        </CommonComponent.Show>
      }
    >
      <Spin spinning={detail.loading}>
        <div className="trace-audit-detail-card">
          {traceId && !detail.error ? (
            <TraceDetail
              key={detailVersion}
              traceId={traceId}
              tagList={tag.data}
              reload={refreshDetail}
            />
          ) : (
            <Result status="error" title={traceId ? "获取溯源详情失败" : "缺少溯源 ID"} />
          )}
        </div>
      </Spin>
    </PageContainer>
  );
}
